export default __webpack_public_path__ + "static/media/radish-5.5c925d5c.svg";